import { graphql, useStaticQuery } from "gatsby";
import moment from "moment";

const addDays = (date, num) => {
    return new Date(date.setDate(date.getDate() + num));
};

export const useMonthlyEvents = () => {
    const {
        events: { nodes },
    } = useStaticQuery(graphql`
        query EventsQuery {
            events: allContentfulEvent(
                sort: { startDate: ASC }
                filter: { placeholder: { ne: true } }
            ) {
                nodes {
                    id
                    booth
                    endDate
                    image {
                        file {
                            contentType
                            url
                        }
                        gatsbyImageData(layout: CONSTRAINED)
                    }
                    showName
                    startDate
                    location
                    venue
                    description {
                        raw
                    }
                    url
                }
            }
        }
    `);

    const eventsList = nodes.filter(
        ({ startDate, endDate }) =>
            addDays(new Date(startDate), 7) >= new Date() ||
            (endDate && addDays(new Date(endDate), 7) >= new Date()),
    );

    return Object.values(
        eventsList.reduce((r, cV) => {
            const labelDate = moment(cV.startDate).format("MMMM YYYY");
            r[labelDate] = r[labelDate] || {
                labelDate,
                datetimeValue: moment(cV.startDate).format("YYYY-MM"),
                events: [],
            };
            r[labelDate].events.push(cV);
            return r;
        }, {}),
    );
};
